import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { PopupNotification } from '../../models/notification/notificationRole.model';
import { NotificationService } from '../../services/notification/notification.service';
import { FormBuilder, FormGroup, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProfileService } from '../../services/profile/profile.service';

@Component({
    selector: 'app-edit-popup-notification',
    templateUrl: './edit-popup-notification.component.html',
    styleUrls: ['./edit-popup-notification.component.css']
})
/** edit-popup-notification component*/
export class EditPopupNotificationComponent {
    /** edit-popup-notification ctor */
  public notification = new PopupNotification();
  popupNotifications: PopupNotification[];
  popupNotificationId: string;
  public Detail: any;
  public mediaList: MediaLibrary[];
  fileToUpload: File;
  fd = new FormData();
  mediaImageShow: boolean;
  modalRef: BsModalRef;
  selectedPopupNotificationLogo: string;
  minDate: Date;
  maxDate: Date;
  endMaxDate: Date;
  editPopupLogo: string;
  validate: boolean;
  userId: number;
  config = {
    animated: true
  };
  configuration = {
    uiColor: '#ffffff',
    toolbarGroups: [{ name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
    { name: 'links' }, { name: 'insert' },
    { name: 'document', groups: ['mode', 'document', 'doctools'] },
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
    { name: 'styles' },
    { name: 'colors' }],
    resize_enabled: false,
    removePlugins: 'save',
    extraPlugins: 'smiley,justify,indentblock,colordialog',
    colorButton_foreStyle: {
      element: 'font',
      attributes: { 'color': '#(color)' }
    },
    height: 188,
    removeDialogTabs: '',
    removeButtons: '',
    format_tags: 'p;h1;h2;h3;pre;div'
  }
  constructor(private _avRoute: ActivatedRoute,private readonly rolePermissionService: RolePermissionService, private readonly notificationService: NotificationService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private formBuilder: FormBuilder, private readonly router: Router,
    private readonly mediaServices: MediaLibraryService, private modalService: BsModalService,
    private readonly profileService: ProfileService) {
    this.checkPermission();
    this.notification.backGroundImage = "";
    this.fileToUpload = null;
    if (this._avRoute.snapshot.params["id"]) {
      this.getPopupNotificationById(this._avRoute.snapshot.params["id"]);
      this.toastr.setRootViewContainerRef(vcr);
      this.notification.sortOrder = 0;
      this.validate = true;
    }
    this.profileService.getProfile().subscribe(
      data => {
        if (data) {
          this.notification.userId = data.userID;
          this.userId = data.userID;
        }
        else {
          this.notification.userId = 0;
        }
      });
  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("notification").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
          }
          else {
            this.router.navigate(["/popupNotification-list"]);
          }
        }
        else {
          this.router.navigate(["/popupNotification-list"]);
        }
      }
    )
  }
  getPopupNotificationById(id: string) {
    this.notificationService.GetPopupNotificationById(id).subscribe(
      data => {
        this.notification = data;
        setTimeout(() => {
          this.Detail = this.notification.popupNotificationDetail;
        }, 2000);
        //this.notification.startDate = this.formatDate(this.notification.startDate);
        //this.notification.endDate = this.formatDate(this.notification.endDate);
      }
    )
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }
      }
    )
  }
  onSubmit() {
    if (typeof this.fileToUpload == "undefined") {
      this.toastr.info('please select popup image', 'Info');
      return;
    }
    //else {
    //  if (this.notification.backGroundImage == "") {
    //    this.toastr.info('please select popup image', 'Info');
    //    return;
    //  }
    //}
    if (this.notification.sortOrder == null) {
      this.notification.sortOrder = 0;
    }
    this.validate = false;
    this.notification.popupNotificationDetail = this.Detail;
    this.notificationService.UpdatePopupNotification(this.notification).subscribe(result => {
      if (result) {
        this.toastr.success('Popup Notification has been Update. ', 'Success');
        this.fd.append("popupNotificationID", result.toString());
        this.notificationService.AddPopupNotificationLogo(this.fd, this.userId);
      }
      else {
        this.toastr.error('Error occurred. Oop!', 'Success');
      }
    });
  }
  uploadPopupNotificationLogo(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("PopupNotificationImage", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.notification.backGroundImage = "";
      this.mediaImageShow = true;
      this.selectedPopupNotificationLogo = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  SlectImage(Image: MediaLibrary) {
    this.fileToUpload = null;
    this.fd = new FormData();
    this.editPopupLogo = Image.fileName;
    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });
    Image.activeDiv = !Image.activeDiv;
  }
  formatDate(date: string): string {
    let newDate: any = date.split('-');
    let days: number = parseInt(newDate[2]);
    let months: number = parseInt(newDate[1]);
    let year: number = parseInt(newDate[0]);
    return months + "/" + days + "/" + year;
  }


  ShowImage() {
    this.notification.backGroundImage = this.editPopupLogo;
    this.selectedPopupNotificationLogo = "";
    this.modalRef.hide();
  }
  HidePopup() {

    this.editPopupLogo = "";
    this.modalRef.hide();
  }
  isActiveCheckbox(e) {
    this.notification.isActive = e.target.checked;
  }
  selectStartDate(e) {
    if (e != null) {
      this.notification.startDate = e;
      this.notification.endDate = e;
      this.maxDate = e;
      this.endMaxDate = new Date(this.maxDate);
      this.endMaxDate.setDate(this.maxDate.getDate());
    }
  }
  selectEndDate(e) {
    if (e != null) {
      this.notification.endDate = e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/notification-components/edit-popup-notification/edit-popup-notification.component.ts